import {CancelledError} from '@tanstack/query-core';
import {ReactNode, useEffect} from 'react';
import {showSimpleDialog} from '../../dialog/simpleDialogHandler';
import {clearError} from '../../errors/ErrorSlice';
import {getSerializedPagewebError} from '../../errors/getSerializedPagewebError.function';
import {PagewebError} from '../../errors/PagewebError.class';
import {PagewebErrorType} from '../../errors/PagewebErrorType.enum';
import {t} from '../getTranslations';
import {requestContext} from '../requestContext';
import {ApiStatusCodeVo} from '../shared/api/nicolas/vo/enums/ApiStatusCodeVo.enum';
import {KakaoLoginError} from '../shared/login-pageweb/KakaoLoginError.class';
import useTypedDispatch from '../useTypedDispatch';
import useTypedSelector from '../useTypedSelector';

export function StoreErrorChecker({children}: {children: ReactNode}) {
  const errorList = useTypedSelector(state => {
    return state.errors.errorList;
  });
  const dispatch = useTypedDispatch();

  useEffect(() => {
    let throwError;

    for (const error of errorList) {
      if (error instanceof KakaoLoginError) {
        showSimpleDialog({
          title: t('login_kakaotalk_authentication_failed_popup'),
          description: t('login_kakaotalk_authentication_failed_retry'),
          isMobile: requestContext.requestInfo.display.isMobile,
          okButton: {
            type: 'label',
            text: t('common_confirm_button'),
            closeAfterClick: true,
          },
        });
        return;
      }
      if (error instanceof CancelledError) {
        // 취소된 요청 에러는 무시합니다.
        return;
      }

      if (
        'isSerializedPagewebError' in error &&
        error.type === PagewebErrorType.CancelledError
      ) {
        // 취소된 요청 에러는 무시합니다.
        return;
      }
      if (
        'isSerializedPagewebError' in error &&
        error.resultCode === ApiStatusCodeVo.FailToLoginWithIncorrectOs
      ) {
        showSimpleDialog({
          title: error.message,
          isMobile: requestContext.requestInfo.display.isMobile,
          okButton: {
            type: 'label',
            text: t('common_confirm_button'),
            closeAfterClick: true,
          },
        });
        return;
      }

      throwError = new PagewebError(getSerializedPagewebError(error));
      break;
    }

    // 에러가 throw되기 전에 redux 상의 에러 정보들을 초기화해줍니다.
    dispatch(clearError());

    if (throwError) {
      throw throwError;
    }
  }, [dispatch, errorList]);

  return <>{children}</>;
}
